"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.About = void 0;
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var selectors_1 = require("../../redux/selectors");
var messageContext_1 = require("../../hoc/messageContext");
var typography_1 = __importDefault(require("antd/es/typography"));
var form_1 = __importDefault(require("antd/es/form"));
var input_1 = __importDefault(require("antd/es/input"));
var button_1 = __importDefault(require("antd/es/button"));
var Title = typography_1.default.Title;
var About = function () {
    var _a, _b, _c;
    var about = (0, react_redux_1.useSelector)(selectors_1.aboutSelector).about;
    var form = form_1.default.useForm()[0];
    var _d = react_1.default.useState(false), loading = _d[0], setLoading = _d[1];
    var _e = (0, messageContext_1.useMessageContext)(), showSuccess = _e.showSuccess, showError = _e.showError;
    (0, react_1.useEffect)(function () {
        var _a, _b, _c;
        if (about === null || about === void 0 ? void 0 : about.length) {
            form.setFieldsValue({
                paragraph_1: (_a = about[0]) === null || _a === void 0 ? void 0 : _a.description,
                paragraph_2: (_b = about[1]) === null || _b === void 0 ? void 0 : _b.description,
                paragraph_3: (_c = about[2]) === null || _c === void 0 ? void 0 : _c.description,
            });
        }
    }, [about, form]);
    var onFinish = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, fetch("".concat(process.env.REACT_APP_BASE_URL, "/about_companies/update_multiple"), {
                            method: 'PATCH',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                                about_companies: [
                                    {
                                        id: 1,
                                        description: values.paragraph_1,
                                    },
                                    {
                                        id: 2,
                                        description: values.paragraph_2,
                                    },
                                    {
                                        id: 3,
                                        description: values.paragraph_3,
                                    },
                                ],
                            }),
                        })];
                case 2:
                    response = _a.sent();
                    console.log("url", "".concat(process.env.REACT_APP_BASE_URL, "/about_companies"));
                    console.log("value", JSON.stringify({
                        about_companies: [
                            {
                                id: 1,
                                description: values.paragraph_1,
                            },
                            {
                                id: 2,
                                description: values.paragraph_2,
                            },
                            {
                                id: 3,
                                description: values.paragraph_3,
                            },
                        ],
                    }));
                    if (!response.ok) {
                        throw new Error("HTTP error! status: ".concat(response.status));
                    }
                    showSuccess('Изменения сохранены');
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    console.error('Error updating about:', error_1);
                    showError('Ошибка при сохранении изменений');
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement("div", { style: { padding: '20px' } },
        react_1.default.createElement(Title, { level: 1 }, "\u041E \u043D\u0430\u0441"),
        react_1.default.createElement(form_1.default, { form: form, onFinish: onFinish, layout: "vertical", initialValues: {
                paragraph_1: (_a = about[0]) === null || _a === void 0 ? void 0 : _a.description,
                paragraph_2: (_b = about[1]) === null || _b === void 0 ? void 0 : _b.description,
                paragraph_3: (_c = about[2]) === null || _c === void 0 ? void 0 : _c.description,
            } },
            react_1.default.createElement(form_1.default.Item, { name: "paragraph_1", label: "\u041F\u0430\u0440\u0430\u0433\u0440\u0430\u0444 1", rules: [{ required: true, message: 'Введите текст' }] },
                react_1.default.createElement(input_1.default.TextArea, { rows: 6, placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0442\u0435\u043A\u0441\u0442" })),
            react_1.default.createElement(form_1.default.Item, { name: "paragraph_2", label: "\u041F\u0430\u0440\u0430\u0433\u0440\u0430\u0444 2", rules: [{ required: true, message: 'Введите текст' }] },
                react_1.default.createElement(input_1.default.TextArea, { rows: 6, placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0442\u0435\u043A\u0441\u0442" })),
            react_1.default.createElement(form_1.default.Item, { name: "paragraph_3", label: "\u041F\u0430\u0440\u0430\u0433\u0440\u0430\u0444 3", rules: [{ required: true, message: 'Введите текст' }] },
                react_1.default.createElement(input_1.default.TextArea, { rows: 3, placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0442\u0435\u043A\u0441\u0442" })),
            react_1.default.createElement(form_1.default.Item, null,
                react_1.default.createElement(button_1.default, { type: "primary", htmlType: "submit", loading: loading }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F")))));
};
exports.About = About;
